/* eslint-disable no-return-assign */
export const cartReducer = (state, { type, payload }) => {
  switch (type) {
    case 'ADD_ITEM':
      if (payload.qtty > 0) {
        const newState = { ...state };
        const itemExists = newState.items.filter(
          (item) => item.variation.id === payload.variation.id,
        );
        if (itemExists.length === 0) {
          newState.items.push(payload);
        } else {
          const index = newState.items.findIndex(
            (item) => item.variation.id === payload.variation.id,
          );
          newState.items[index] = payload;
        }
        if (newState.items.length > 0) {
          newState.amount = newState.items.reduce(
            (prev, current) =>
              (prev += current.qtty * current.variation.wholesalePrice),
            0,
          );
        } else {
          newState.amount = 0;
        }
        return newState;
      }
      return state;

    case 'REMOVE_ITEM':
      if (payload.qtty === 0) {
        const newState = { ...state };
        const itemToRemove = newState.items
          .filter((item) => item.variation.id === payload.variation.id)
          .map((filtered) => filtered);
        if (itemToRemove.length > 0) {
          newState.items = newState.items.filter(
            (item) => item.variation.id !== payload.variation.id,
          );
        }
        if (newState.items.length > 0) {
          newState.amount = newState.items.reduce(
            (prev, current) =>
              (prev -= current.qtty * current.variation.wholesalePrice),
            0,
          );
          if (newState.amount < 0) {
            newState.amount *= -1;
          }
        } else {
          newState.amount = 0;
        }
        return newState;
      }
      return state;

    case 'CLEAR_CART':
      return {
        items: [],
        amount: 0,
        user: {},
      };
    default:
      return state;
  }
};
